<template>
  <header class="scn-header" :class="alignment ? `text-${alignment}` : undefined">
    <div class="title-ctn">
      <div class="dot" :class="{'dot--green': green}" />
      <h3 class="title">
        <span v-for="item in checkedTitle" :class="{'title__highlight' : item.isHighlighted}">
          {{ item.word }}
        </span>
      </h3>
    </div>
    <div class="divider" :class="{'divider--green': green}" />
    <p class="subtitle">
      {{ subtitle }}
    </p>
  </header>
</template>
<script>
export default {
  name: 'SectionHeader',
  data () {
    return {
      checkedTitle: []
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    highlightedWordIndex: {
      type: [String, Number],
      default: 'last'
    },
    alignment: {
      type: String,
      default: 'center'
    },
    green: Boolean
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    }
  },
  methods: {
    separateWords () {
      const titleWords = this.title.split(' ')
      let index
      if (this.highlightedWordIndex === 'last') index = titleWords.length - 1
      else index = this.highlightedWordIndex
      titleWords.forEach((word, wordIndex) => {
        const obj = {
          word,
          isHighlighted: wordIndex === index
        }
        this.checkedTitle.push(obj)
      })
    }
  },
  watch: {
    currentLocale () {
      this.checkedTitle = []
      this.separateWords()
    }
  },
  created () {
    this.separateWords()
  },
  comments: true
}
</script>
<style scoped lang="sass">
/* purgecss start ignore */
@tailwind utilities

.scn-header
  @apply block

.title-ctn
  @apply inline-flex items-center uppercase

.dot
  @apply inline-block bg-pink h-3 w-3 mr-2
  &--green
    @apply bg-green-dark

.title
  @apply text-4xl
  @screen md
    @apply text-5xl
  & > span
    @apply font-thin
    &.title__highlight
      @apply font-condensed

.divider
  @apply h-px mb-1 mx-auto
  width: 80vw
  background: linear-gradient(90deg, transparent, #d8306a, transparent)
  @screen md
    width: 350px
  &--green
    background: linear-gradient(90deg, transparent, #076633, transparent)

.subtitle
  @apply uppercase
/* purgecss end ignore */
</style>
